import React from 'react';
import styled from 'styled-components';
import IrContainer from '../view/notice/container/IrContainer';
import SubLayout from '../view/shared/layout/SubLayout';


const Ir = () => {
    return (
    <Container>
        <SubLayout>
        <IrContainer/>
        </SubLayout>
    </Container>
    );
};




const Container = styled.div `

 
`;


export default Ir;